module.exports = __webpack_public_path__ + "static/media/875889d7.jpg";